import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, form} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormBody, FormActions} = form;
import CustomCheckboxField from "../components/CustomCheckboxField";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář pro tvorbu/úpravu dopravce.
 */
class DopravceForm extends Component<WithTranslation> {

    static formName = 'DopravceForm';

    static validate = (values, props) => {
        const {t} = props;
        const errors = {};
        if (!values.kodDopravce) {
            errors.kodDopravce = t('validation.delivery_code_required');
        }
        if (!values.dopravce) {
            errors.dopravce = t('validation.carrier_name_required');
        }
        return errors;
    };

    render() {
        const {onClose, submitting, handleSubmit, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.String label={t('labels.code')} name="kodDopravce" required disabled={submitting}/>
                <ff.String label={t('labels.name')} name="dopravce" required disabled={submitting}/>
                <CustomCheckboxField label={t('labels.inactive')} name="neaktivni" disabled={submitting}/>
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

export default withTranslation()(connect()(reduxForm({
    form: DopravceForm.formName,
    validate: DopravceForm.validate,
})(DopravceForm)));
